import fp from 'lodash/fp'
import React from 'react'
import { combine, withContext, withCallbacks } from 'react-hooks-combine'
import { useHistory } from 'react-router-dom'
import { withFormModel } from 'shared/hooks'
import { spec, validators } from 'utils/validation'
import { StoreContext } from 'store/context'
import { observer } from 'mobx-react'
import { showNotificationBasedOnDevice, redirectToProfileWithNotification } from 'utils/notification-helper'

import PersonalInfoComponent from './component'

const { string, any } = validators

// Create the form-enabled component
const PersonalInfoWithForm = combine({
	hooks: [
		withContext('appStore', StoreContext),
		withFormModel((_state, { initialValues = {} }) => {
			return {
				email: {
					readonly: true,
					initialValue: initialValues.email || '',
					spec: spec.flow(string.isNotEmpty, any.required),
				},

				firstName: {
					alias: 'First name',
					initialValue: initialValues.firstName || '',
					spec: spec.flow(string.isString),
				},

				lastName: {
					alias: 'Last name',
					initialValue: initialValues.lastName || '',
					spec: spec.flow(string.isString),
				},

				nickName: {
					alias: 'Nickname',
					initialValue: initialValues.nickName || '',
					spec: spec.flow(string.isString),
				},
			}
		}),

		withCallbacks({
			onSubmit:
				({ appStore }) =>
					async (data) => {
						const isMobile = window.innerWidth <= 767

						try {
							const loggedEntity = appStore?.auth?.loggedEntity
							if (!loggedEntity) {
								if (isMobile) {
									// Mobile: Show notification and redirect to profile (top notification only)
									redirectToProfileWithNotification(null, 'error', 'Changes unsaved', true)
								} else {
									// Desktop: Show toaster notification only
									showNotificationBasedOnDevice('error', 'Changes unsaved')
								}
								return
							}

							const updateData = {
								firstName: data.firstName,
								lastName: data.lastName,
								nickName: data.nickName,
							}
							await loggedEntity.update(updateData)

							if (isMobile) {
								// Mobile: Show notification and redirect to profile (top notification only)
								redirectToProfileWithNotification(null, 'success', null, true)
							} else {
								// Desktop: Show toaster notification only
								showNotificationBasedOnDevice('success')
							}

						} catch (error) {
							if (isMobile) {
								// Mobile: Show notification and redirect to profile (top notification only)
								redirectToProfileWithNotification(null, 'error', 'Changes unsaved', true)
							} else {
								// Desktop: Show toaster notification only
								showNotificationBasedOnDevice('error', 'Changes unsaved')
							}
						}
					},
		}),
	],

	transformProps: ({ appStore, form, onSubmit }) => ({
		loggedEntity: appStore?.auth?.loggedEntity,
		form,
		onSubmit,
	}),
})(observer(PersonalInfoComponent))

// Wrapper component that provides initialValues
const PersonalInfoWrapper = combine({
	hooks: [
		withContext('appStore', StoreContext),
	],
	transformProps: ({ appStore }) => {
		return {
			initialValues: appStore?.auth?.loggedEntity || {},
		}
	},
})(({ initialValues }) => {
	return <PersonalInfoWithForm initialValues={initialValues} />
})

export default PersonalInfoWrapper 